<section class="filmstrip story-rail" [style.--fs-accent]="gallery.lightboxAccentColor || '#a5eb55'">
  @if (showGalleryHeading || gallery.intro) {
  <div class="filmstrip__header">
    @if (showGalleryHeading) {
    <div class="filmstrip__eyebrow">
      <span class="filmstrip__eyebrow-num">{{ displayOrderLabel }}</span>
      <span class="filmstrip__eyebrow-sep">—</span>
      <span class="filmstrip__eyebrow-label">{{ headerLabel || 'Gallery' }}</span>
    </div>
    @if (gallery.title) {
    <h3 class="filmstrip__title">{{ gallery.title }}</h3>
    }
    }
    @if (gallery.intro) {
    <p class="filmstrip__intro">{{ gallery.intro }}</p>
    }
  </div>
  }

  <div class="filmstrip__rail">
    @for (pair of pairedItems; track pair.primary._trackKey) {
    <article
      #slideRef
      class="filmstrip__slide"
      [ngClass]="getSlideClasses(pair.originalIndex, pair.primary)"
      [class.filmstrip__slide--align-left]="pair.primary._canvasAlign === 'left'"
      [class.filmstrip__slide--align-center]="pair.primary._canvasAlign === 'center'"
      [class.filmstrip__slide--align-right]="pair.primary._canvasAlign === 'right'"
      [style.--filmstrip-stagger]="getSlideStagger(pair.originalIndex)">
      @let item = pair.primary;
      @let companion = pair.companion;
      @let i = pair.originalIndex;

      @if (item._isText) {
      <div
        class="filmstrip__text-card"
        [class.filmstrip__text-card--body-only]="!item.eyebrow && !item.title"
        [class.filmstrip__text-card--with-heading]="!!(item.eyebrow || item.title)">
        @if (item.eyebrow) {
        <span class="filmstrip__text-eyebrow">{{ item.eyebrow }}</span>
        }
        @if (item.title) {
        <h4 class="filmstrip__card-title">{{ item.title }}</h4>
        }
        @if (item.body) {
        <div class="filmstrip__body">
          @for (paragraph of getBodyParagraphs(item.body); track $index) {
          <p>{{ paragraph }}</p>
          }
        </div>
        }
      </div>
      } @else if (item._isVideo) {
      <div class="filmstrip__scene-stage" [class.filmstrip__scene-stage--parallax]="isParallaxComposition(item, i)">
      <div
        class="filmstrip__composition"
        [class.filmstrip__composition--split]="!!companion"
        [class.filmstrip__composition--main-left]="item._canvasAlign === 'left'"
        [class.filmstrip__composition--main-center]="item._canvasAlign === 'center'"
        [class.filmstrip__composition--main-right]="item._canvasAlign === 'right'">
        <figure
          class="filmstrip__media-frame filmstrip__media-frame--clickable"
          [class.filmstrip__media-frame--size-standard]="item._displaySize === 'standard'"
          [class.filmstrip__media-frame--size-wide]="item._displaySize === 'wide'"
          [class.filmstrip__media-frame--size-tall]="item._displaySize === 'tall'"
          [class.filmstrip__media-frame--size-feature]="item._displaySize === 'feature'"
          [class.filmstrip__media-frame--size-full]="item._displaySize === 'full'"
          [class.filmstrip__media-frame--full]="isFullViewportComposition(item, i)"
          [class.filmstrip__media-frame--parallax]="isParallaxComposition(item, i)"
          [class.filmstrip__media-frame--ratio-landscape]="item.aspectRatio === 'landscape'"
          [class.filmstrip__media-frame--ratio-portrait]="item.aspectRatio === 'portrait'"
          [class.filmstrip__media-frame--ratio-square]="item.aspectRatio === 'square'"
          [class.filmstrip__media-frame--ratio-cinematic]="item.aspectRatio === 'cinematic'"
          [class.filmstrip__media-frame--align-left]="item._canvasAlign === 'left'"
          [class.filmstrip__media-frame--align-center]="item._canvasAlign === 'center'"
          [class.filmstrip__media-frame--align-right]="item._canvasAlign === 'right'"
          (click)="openLightboxAt(i)">
          <div
            class="filmstrip__media-surface"
            [class.filmstrip__media-surface--has-overlay]="item._captionMode === 'overlay' && !!(item.eyebrow || item.title || item.caption)">
            <video
              class="filmstrip__media"
              controls
              playsinline
              preload="metadata"
              [poster]="item._posterUrl || item._placeholderSrc || null"
              [muted]="item.muted ?? true"
              [autoplay]="item.autoplay ?? false"
              [appLazyVideoSource]="item._mediaUrl"
            >
            </video>
            @if (getCredit(item)) {
            <span class="filmstrip__credit">{{ getCredit(item) }}</span>
            }
            @if (isFullViewportComposition(item, i)) {
              <div class="filmstrip__reveal-overlay filmstrip__reveal-overlay--left" aria-hidden="true"></div>
              <div class="filmstrip__reveal-overlay filmstrip__reveal-overlay--right" aria-hidden="true"></div>
            }
            @if (item._captionMode === 'overlay' && (item.eyebrow || item.title || item.caption)) {
            <figcaption class="filmstrip__caption filmstrip__caption--overlay">
              @if (item.eyebrow) {
              <span class="filmstrip__caption-eyebrow">{{ item.eyebrow }}</span>
              }
              @if (item.title) {
              <strong>{{ item.title }}</strong>
              }
              @if (item.caption) {
              <span>{{ item.caption }}</span>
              }
            </figcaption>
            }
          </div>
          @if (item._captionMode === 'below' && (item.eyebrow || item.title || item.caption)) {
          <figcaption class="filmstrip__caption filmstrip__caption--below">
            @if (item.eyebrow) {
            <span class="filmstrip__caption-eyebrow">{{ item.eyebrow }}</span>
            }
            @if (item.title) {
            <strong>{{ item.title }}</strong>
            }
            @if (item.caption) {
            <span>{{ item.caption }}</span>
            }
          </figcaption>
          }
        </figure>

        @if (companion) {
        <button
          type="button"
          class="filmstrip__companion"
          (click)="openLightboxAt(i + 1)"
          [attr.aria-label]="'Open supporting image ' + (i + 2)">
          <img
            class="filmstrip__companion-media"
            [src]="companion._isVideo ? (companion._posterUrl || companion._imageSrc || companion._thumbSrc) : (companion._imageSrc || companion._thumbSrc)"
            [attr.srcset]="companion._isVideo ? null : (companion._imageSrcSet || null)"
            sizes="(max-width: 767px) calc(100vw - 2rem), (max-width: 960px) 32vw, (max-width: 1440px) 36vw, 34rem"
            [alt]="companion.alt || companion.caption || ('Supporting image ' + (i + 2))"
            loading="lazy"
            decoding="async" />
          @if (getCredit(companion)) {
          <span class="filmstrip__credit filmstrip__credit--companion">{{ getCredit(companion) }}</span>
          }
          @if (companion._captionMode !== 'hidden' && (companion.eyebrow || companion.title || companion.caption)) {
          <span class="filmstrip__companion-caption">
            @if (companion.eyebrow) {
            <span class="filmstrip__companion-eyebrow">{{ companion.eyebrow }}</span>
            }
            @if (companion.title) {
            <strong>{{ companion.title }}</strong>
            }
            @if (companion.caption) {
            <span>{{ companion.caption }}</span>
            }
          </span>
          }
        </button>
        }
      </div>
      </div>
      } @else {
      <div class="filmstrip__scene-stage" [class.filmstrip__scene-stage--parallax]="isParallaxComposition(item, i)">
      <div
        class="filmstrip__composition"
        [class.filmstrip__composition--split]="!!companion"
        [class.filmstrip__composition--main-left]="item._canvasAlign === 'left'"
        [class.filmstrip__composition--main-center]="item._canvasAlign === 'center'"
        [class.filmstrip__composition--main-right]="item._canvasAlign === 'right'">
        <figure
          class="filmstrip__media-frame"
          [class.filmstrip__media-frame--size-standard]="item._displaySize === 'standard'"
          [class.filmstrip__media-frame--size-wide]="item._displaySize === 'wide'"
          [class.filmstrip__media-frame--size-tall]="item._displaySize === 'tall'"
          [class.filmstrip__media-frame--size-feature]="item._displaySize === 'feature'"
          [class.filmstrip__media-frame--size-full]="item._displaySize === 'full'"
          [class.filmstrip__media-frame--full]="isFullViewportComposition(item, i)"
          [class.filmstrip__media-frame--parallax]="isParallaxComposition(item, i)"
          [class.filmstrip__media-frame--ratio-landscape]="item.aspectRatio === 'landscape'"
          [class.filmstrip__media-frame--ratio-portrait]="item.aspectRatio === 'portrait'"
          [class.filmstrip__media-frame--ratio-square]="item.aspectRatio === 'square'"
          [class.filmstrip__media-frame--ratio-cinematic]="item.aspectRatio === 'cinematic'"
          [class.filmstrip__media-frame--align-left]="item._canvasAlign === 'left'"
          [class.filmstrip__media-frame--align-center]="item._canvasAlign === 'center'"
          [class.filmstrip__media-frame--align-right]="item._canvasAlign === 'right'">
          <div
            class="filmstrip__media-surface"
            [class.filmstrip__media-surface--has-overlay]="item._captionMode === 'overlay' && !!(item.eyebrow || item.title || item.caption)">
            <img
              class="filmstrip__media"
              [src]="item._imageSrc"
              [attr.srcset]="item._imageSrcSet || null"
              [attr.sizes]="isFullViewportComposition(item, i) ? '100vw' : 'min(100vw, 86rem)'"
              [alt]="item.alt || item.caption || ('Story image ' + (i + 1))"
              [attr.loading]="i === 0 ? 'eager' : 'lazy'"
              decoding="async"
              [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
            />
            @if (getCredit(item)) {
            <span class="filmstrip__credit">{{ getCredit(item) }}</span>
            }
            @if (isFullViewportComposition(item, i)) {
              <div class="filmstrip__reveal-overlay filmstrip__reveal-overlay--left" aria-hidden="true"></div>
              <div class="filmstrip__reveal-overlay filmstrip__reveal-overlay--right" aria-hidden="true"></div>
            }
            <button
              type="button"
              class="filmstrip__expand"
              aria-label="Open fullscreen gallery"
              (click)="$event.stopPropagation(); openLightboxAt(i)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 3 21 3 21 9"></polyline>
                <polyline points="9 21 3 21 3 15"></polyline>
                <line x1="21" y1="3" x2="14" y2="10"></line>
                <line x1="3" y1="21" x2="10" y2="14"></line>
              </svg>
            </button>
            @if (item._captionMode === 'overlay' && (item.eyebrow || item.title || item.caption)) {
            <figcaption class="filmstrip__caption filmstrip__caption--overlay">
              @if (item.eyebrow) {
              <span class="filmstrip__caption-eyebrow">{{ item.eyebrow }}</span>
              }
              @if (item.title) {
              <strong>{{ item.title }}</strong>
              }
              @if (item.caption) {
              <span>{{ item.caption }}</span>
              }
            </figcaption>
            }
          </div>
          @if (item._captionMode === 'below' && (item.eyebrow || item.title || item.caption)) {
          <figcaption class="filmstrip__caption filmstrip__caption--below">
            @if (item.eyebrow) {
            <span class="filmstrip__caption-eyebrow">{{ item.eyebrow }}</span>
            }
            @if (item.title) {
            <strong>{{ item.title }}</strong>
            }
            @if (item.caption) {
            <span>{{ item.caption }}</span>
            }
          </figcaption>
          }
        </figure>

        @if (companion) {
        <button
          type="button"
          class="filmstrip__companion"
          (click)="openLightboxAt(i + 1)"
          [attr.aria-label]="'Open supporting image ' + (i + 2)">
          <img
            class="filmstrip__companion-media"
            [src]="companion._isVideo ? (companion._posterUrl || companion._imageSrc || companion._thumbSrc) : (companion._imageSrc || companion._thumbSrc)"
            [attr.srcset]="companion._isVideo ? null : (companion._imageSrcSet || null)"
            sizes="(max-width: 767px) calc(100vw - 2rem), (max-width: 960px) 32vw, (max-width: 1440px) 36vw, 34rem"
            [alt]="companion.alt || companion.caption || ('Supporting image ' + (i + 2))"
            loading="lazy"
            decoding="async" />
          @if (getCredit(companion)) {
          <span class="filmstrip__credit filmstrip__credit--companion">{{ getCredit(companion) }}</span>
          }
          @if (companion._captionMode !== 'hidden' && (companion.eyebrow || companion.title || companion.caption)) {
          <span class="filmstrip__companion-caption">
            @if (companion.eyebrow) {
            <span class="filmstrip__companion-eyebrow">{{ companion.eyebrow }}</span>
            }
            @if (companion.title) {
            <strong>{{ companion.title }}</strong>
            }
            @if (companion.caption) {
            <span>{{ companion.caption }}</span>
            }
          </span>
          }
        </button>
        }
      </div>
      </div>
      }

      @if (!item._isText && (item.body || companion?.body)) {
      <div
        class="filmstrip__scene-copy"
        [class.filmstrip__scene-copy--after-caption]="item._captionMode === 'below' && !!(item.eyebrow || item.title || item.caption)"
        [class.filmstrip__scene-copy--parallax]="isParallaxComposition(item, i)">
        @if (item.body) {
        @for (paragraph of getBodyParagraphs(item.body); track $index) {
        <p class="filmstrip__scene-body">{{ paragraph }}</p>
        }
        }
        @if (companion?.body) {
        @for (paragraph of getBodyParagraphs(companion?.body); track $index) {
        <p class="filmstrip__scene-body filmstrip__scene-body--companion">{{ paragraph }}</p>
        }
        }
      </div>
      }
    </article>
    }
  </div>

  @if (lightbox.isOpen) {
    <app-lightbox
      [items]="items"
      [activeIndex]="lightbox.index"
      [showThumbnails]="showLightboxThumbnails"
      [accentColor]="gallery.lightboxAccentColor ?? null"
      [analyticsLayout]="gallery.layout"
      (closeLightbox)="onLightboxClose()"
      (indexChange)="onLightboxIndexChange($event)">
    </app-lightbox>
  }
</section>
